// common
import React, { useEffect, useRef, useState } from "react"

import "./styles.css"

// redux
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock"

// components
import Button from "../button"
import clsx from "clsx"
import { debounce } from "../../helpers/debounce"
import { useLanguage } from "@languages/index"

// Props Interface
interface Props {
  className?: any
  style?: any
  zIndex?: any

  sheet?: any
  modal?: any
  popup?: any

  setSheet?: any
  preferences?: any
  setPreferences?: any
}

const SheetContainer: React.FunctionComponent<Props> = (props: Props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.component.sheet }

  const sheetRef = useRef()
  const [opened, setIsOpened] = useState<any>()
  const fadeOutDuration = 300

  const openSheet = () => {
    debounce(() => {
      if (!opened) {
        setIsOpened(true)
        if (sheetRef.current && props.popup?.isVisible == false && props.modal?.isVisible == false) {
          if (!props.preferences.isScrollLocked) {
            // console.log("sheet", "scroll-locked");
            // disableBodyScroll(sheetRef.current);
            // props.setPreferences({
            //   isScrollLocked: true,
            //   scrollY: window.scrollY,
            // });
          }
        }
      }
    }, 200)
  }

  const closeSheet = () => {
    if (props.sheet.onRequestClose) {
      props.sheet.onRequestClose()
    }

    if (props.sheet.preventClose) {
      return false
    }

    if (opened) {
      setIsOpened(false)
    }

    debounce(() => {
      props.setSheet({ isVisible: false })
    }, fadeOutDuration)
  }

  useEffect(() => {
    if (props.sheet.isVisible) openSheet()
    // if (!props.sheet.isVisible) closeSheet();
  }, [props.sheet.isVisible])

  useEffect(() => {
    if (props.sheet.closeSheet) {
      closeSheet()
    }
  }, [props.sheet.closeSheet])

  if (!props.sheet.isVisible) {
    return <></>
  }

  const renderCustomSheet = () => {
    if (!props.sheet.content) {
      return null
    }

    return props.sheet.content()
  }

  const renderDefaultSheet = () => {
    if (props.sheet.content) {
      return null
    }

    const onConfirm = () => {
      if (props.sheet.confirm) {
        props.sheet.confirm()
      }

      closeSheet()
    }

    const onCancel = () => {
      if (props.sheet.cancel) {
        props.sheet.cancel()
      }

      closeSheet()
    }

    const renderTitle = () => {
      if (!props.sheet.title) {
        return null
      }

      return <span className="prose prose-xl text-black">{props.sheet.title}</span>
    }

    const renderText = () => {
      return (
        <span className="prose prose-md text-black" style={{ whiteSpace: "pre-wrap" }}>
          {props.sheet.text}
        </span>
      )
    }

    const windowBackgroundColor = "white"

    const renderSheetWindow = () => {
      return (
        <div className="flex flex-col justify-center align-center p-5" style={{ backgroundColor: windowBackgroundColor }}>
          <div className="content flex flex-col">
            {renderTitle()}
            {renderText()}
          </div>
          <div className="buttons flex flex-row columns-2 mt-4 gap-1.5">
            {props.sheet.cancel ? <Button text={languageTexts.cancel} onClick={() => onCancel()} /> : null}
            {!props.sheet.hideConfirmButton ? <Button text={languageTexts.confirm} onClick={() => onConfirm()} /> : null}
          </div>
        </div>
      )
    }

    return renderSheetWindow()
  }

  const shadowStyle = {
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
  }

  const defaultClassNames = props.sheet.className ? "sheet mt-auto" + props.sheet.className : "sheet mt-auto max-w-lg"

  return (
    <div className="sheet-container flex flex-col" style={{ zIndex: props.sheet.zIndex ? props.sheet.zIndex : null }}>
      <div
        className={clsx(defaultClassNames, "animate__animated animate__slideInUp", "max-h-[100dvh]")}
        style={{
          ...{
            maxHeight: props.sheet.maxHeight ? props.sheet.maxHeight : "100dvh",
            maxWidth: "100vw"
          },
          ...shadowStyle
        }}
        ref={sheetRef}
      >
        {renderCustomSheet()}
        {renderDefaultSheet()}
      </div>

      <div
        className="background-dimmer animate__animated animate__fadeIn"
        onClick={(event) => {
          closeSheet()
        }}
      />
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(SheetContainer)
